import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closeMenu",
  "use": "icon-closeMenu-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol viewBox=\"0 0 16 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-closeMenu\">\n    <path d=\"M0 14.1553H16V12.302H0V14.1553ZM5.40797 9.67H16V7.81178H5.40797V9.67061V9.67ZM5.40797 6.16023H16V4.30571H5.40797V6.16085V6.16023ZM0 0V1.85576H16V0H0ZM3.61618 10.1793L0 7.46486L3.61618 3.9022V10.1793Z\" fill=\"black\" fill-opacity=\"0.4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol